import React from "react"
import cn from "classnames"
import { Flex, ContentCell } from "src/components/Grid"
import groupBy from "lodash/groupBy"
import { P } from "@infotech/uikit-text"
import { Box } from "@infotech/uikit-grid"
import EventTypesMenuIcon from "src/icons/eventTypesMenu.svg"
import { PlanTasksIcon, LinkIcon, LockedIcon } from "@infotech/uikit-icons"
import PaperEditIcon from "src/icons/paperEdit.svg"
import TrashIcon from "src/icons/trashMultiselect.svg"
import ListViewIcon from "src/icons/listView.svg"
import LoaderBox from "src/components/forms/fragments/LoaderBox"
import FieldSet from "@infotech/uikit-fieldset"
import ExternalLink from "src/components/ExternalLink"
import TimeIcon from "src/icons/timePopap.svg"
import DeletedIcon from "src/icons/deleted.svg"
import moment from "moment"
import ModalConfirm from "src/components/modals/ModalConfirm"
import eventModel from "src/models/event"
import GlobalEscapeHandle from "src/components/GlobalEscapeHandle"
import {
  selectStatusAvailable,
  selectEventCustomField,
} from "src/engine/modules/features/selectors"
import { lockedStyle } from "src/helpers/invalidStyle"
import { selectEvent } from "src/engine/modules/calendar/selectors"
import { connect } from "react-redux"
import get from "lodash/get"
import debounce from "lodash/debounce"
import tooltip from "@infotech/uikit-tooltip"
import * as entity from "src/engine/modules/entity"
import { makeTransparent } from "src/containers/Calendar/helpers/eventToItem"
import ValidateCarousel from "src/components/ValidateCarousel"
import StatusSelect from "src/components/Selects/StatusSelect"

// widget imports
import EventCardConnectedInfo from "src/widgets/EventCardConnectedInfo"

import styles from "./styles.css"

const TooltipSpan = tooltip.span()

function stringify(value) {
  return typeof value === `string` ? value : `${value}px`
}
class EventCard extends React.Component {
  targetElement = null

  state = {
    positionXShift: `50%`,
    positionYShift: `50%`,
    isConfirmationModalOpen: false,
  }

  // eslint-disable-next-line camelcase, react/sort-comp
  UNSAFE_componentWillMount() {
    this.refoundTargetElement(this.props)
    if (this.element) {
      this.element.addEventListener(`mousewheel`, e => {
        this.element.scrollTop += e.deltaY
      })
    }
  }

  componentDidMount() {
    window.addEventListener(`resize`, this.onWindowChange)
    if (this.element) {
      this.element.addEventListener(`mousewheel`, e => {
        this.element.scrollTop += e.deltaY
      })
    }
    if (this.targetElement) {
      this.targetElement.addEventListener(`click`, el => {
        this.checkPosition(el.clientX)
      })
    }
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props
    if (nextProps.id !== prevProps.id) {
      this.refoundTargetElement(nextProps)
      this.checkPosition()
    }
    // here we check a moment, when we get eventResources and need to recount widow position just 1 time
    if (
      !nextProps.eventResources.pending &&
      prevProps.eventResources.data !== nextProps.eventResources.data
    ) {
      this.checkPosition(false)
    }
  }

  /* This method recalculates position of Card relative top and buttom screen
   * edges and moves it in such a way so that it can be fully seen */
  // Eslint works wrong in this case
  // eslint-disable-next-line react/sort-comp
  checkPosition = mousePositionX => {
    const { groupPosition } = this.props

    if (this.element) {
      const {
        width: selfWidth,
        height: selfHeight,
      } = this.element.getBoundingClientRect()
      let nextXShift = `50%`
      if (this.targetElement) {
        const { width, left, top } = this.targetElement.getBoundingClientRect()
        /* Calculate X shift */
        if (width + selfWidth > window.innerWidth) {
          if (left < 0 && left + width + selfWidth < window.innerWidth) {
            // Calculate X left infinity event
            nextXShift = left + width + selfWidth / 2 + 12
          } else if (left > 0 && left > selfWidth + 228) {
            // Calculate X right infinity event
            nextXShift = left - selfWidth / 2 - 12
          } else if (
            mousePositionX &&
            width + selfWidth + 228 > window.innerWidth
          ) {
            // Calculate X left and right infinity event
            if (mousePositionX + selfWidth > window.innerWidth) {
              nextXShift = mousePositionX - selfWidth / 2 - 12
            } else {
              nextXShift = mousePositionX + selfWidth / 2 + 12
            }
          }
        } else if (width + selfWidth + 228 > window.innerWidth) {
          if (mousePositionX && width + selfWidth + 228 > window.innerWidth) {
            // Calculate X large event
            if (mousePositionX + selfWidth > window.innerWidth) {
              nextXShift = mousePositionX - selfWidth / 2 - 12
            } else {
              nextXShift = mousePositionX + selfWidth / 2 + 12
            }
          }
        } else if (width <= selfWidth) {
          // Calculate X small event with right space
          nextXShift = left + selfWidth / 2 + width + 12

          if (nextXShift + selfWidth / 2 > window.innerWidth) {
            // Calculate X small event without right space
            nextXShift = left - selfWidth / 2 - 12
          }
        }
        /* Calculate Y shift */
        let nextYShift = top + selfHeight / 2
        if (nextYShift + selfHeight / 2 > window.innerHeight) {
          nextYShift = window.innerHeight - selfHeight / 2 - 24
          if (selfHeight > window.innerHeight - 156) {
            nextYShift = 143 + selfHeight / 2
          }
        }
        // mousePositionX === false - situation, when we need to change only Y-position
        if (mousePositionX === false) {
          this.setState({
            positionYShift: nextYShift,
          })
        } else {
          this.setState({
            positionXShift: nextXShift,
            positionYShift: nextYShift,
          })
        }
      } else if (groupPosition) {
        const groupElement = groupPosition.getBoundingClientRect()
        // check card modal with group modal
        const groupX = groupElement.x
        const groupY = groupElement.top
        let nextYShift = groupY + selfHeight / 2
        // check x position on left
        if (groupX + selfWidth + 312 > window.innerWidth) {
          nextXShift = groupX - selfWidth / 2 - 12
        } else {
          // check x position on right
          nextXShift = groupX + 312 + selfWidth / 2
        }
        if (nextYShift + selfHeight / 2 > window.innerHeight) {
          nextYShift = window.innerHeight - 16 - selfHeight / 2
        }
        this.setState({
          positionXShift: nextXShift,
          positionYShift: nextYShift,
        })
      }
    } else {
      /* Reset position of card if event element is not found */
      this.setState({
        positionXShift: `50%`,
        positionYShift: `50%`,
      })
    }
  }

  onWindowChange = debounce(this.checkPosition, 100)

  refoundTargetElement(props) {
    const el = document.querySelector(`[eventid="${props.id}"]`)
    if (el) {
      this.targetElement = el
    }
  }

  handleToggleConfirmationModalOpen = () => {
    this.setState(state => ({
      isConfirmationModalOpen: !state.isConfirmationModalOpen,
    }))
  }

  componentDidUnmout() {
    window.removeEventListener(`resize`, this.onWindowChange)
  }

  handleScroll = e => {
    e.stopPropagation() // So timeline doesn't scroll left or right
  }

  handleEdit = () => {
    const {
      history: {
        push,
        location: { pathname, search },
      },
      data: { uuid, originId },
    } = this.props
    const eventId = uuid || originId
    push(`${pathname}/events/${eventId}${search || ``}`)
  }

  handleRemove = e => {
    e.preventDefault()
    e.stopPropagation()
    const { dispatch, data, onSelect, handleEventRemove } = this.props
    const { uuid, originId } = data
    const eventId = uuid || originId
    dispatch(
      entity.actions.creators.remove(eventModel, eventId, () => {
        if (onSelect) {
          onSelect(null)
        }
        if (handleEventRemove) {
          handleEventRemove(data.original)
        }
        this.setState({ isConfirmationModalOpen: false })
      }),
    )
  }

  handleClose = () => {
    const { onSelect } = this.props
    /* Pass select to unselect all */
    if (onSelect) {
      onSelect(null)
    }
  }

  handleEscapePress = () => {
    const { isConfirmationModalOpen } = this.state

    if (isConfirmationModalOpen) {
      this.handleToggleConfirmationModalOpen()
    } else {
      this.handleClose()
    }
  }

  render() {
    const {
      data,
      eventUuid,
      eventResources,
      stackEvent,
      handleEventModalData,
      planAllEventsValidate,
      disableDelete,
      disableStatus,
      CustomEditIcon,
      irStatusAvailable,
      match: {
        params: { scale },
      },
      calendarEventData,
      featuresCustomField,
    } = this.props

    const {
      positionXShift,
      positionYShift,
      isConfirmationModalOpen,
    } = this.state

    const {
      original,
      originalStartTime,
      originalEndTime,
      endDateTime,
      startDateTime,
      type,
      name,
      planInfo,
      description,
      onlyDate,
      color,
      eventType,
      eventTypeColor,
      eventTypeName,
    } = data

    const planLocked = get(planInfo, `locked`, false)

    // custom field logic
    const isCustomFieldAvailable =
      get(featuresCustomField, `enable`) && get(original, `customField`)

    const isYear = scale === `year`
    const { status, restrictions, locked } = isYear ? data : calendarEventData
    const showStatus = Boolean(irStatusAvailable && status)
    const typeColor = makeTransparent(
      color || get(eventType, `color`) || eventTypeColor,
      `0.4`,
    )
    const eventTypeExternalLink = get(original, `externalLink`)
    const typeForGroup = get(eventType, `name`) || eventTypeName
    const start = originalEndTime ? originalStartTime.clone() : startDateTime
    const end = originalEndTime ? originalEndTime.clone() : endDateTime
    const eventResourcesData = eventResources.data
    const eventResourcesPending = eventResources.pending
    const deleteButton =
      disableDelete || planLocked || get(restrictions, `delete`) ? null : (
        <ContentCell className={styles[`icon-title-wrapper`]}>
          <TooltipSpan
            onClick={this.handleToggleConfirmationModalOpen}
            tooltip="Удалить событие"
            tooltipConfig={{
              placement: `bottom`,
            }}
          >
            <TrashIcon size="medium" className={styles.icon} />
          </TooltipSpan>
        </ContentCell>
      )

    const EditIcon = CustomEditIcon || PaperEditIcon

    const showLockedStyle = planLocked || locked
    const lockedTitleStyle = lockedStyle(typeColor)

    return (
      <div>
        {stackEvent ? (
          <div>
            <GlobalEscapeHandle onEscapePress={handleEventModalData} />
            <div
              className={styles.cardOverlay}
              onClick={handleEventModalData}
            />
          </div>
        ) : (
          <div>
            <GlobalEscapeHandle onEscapePress={this.handleEscapePress} />
            <div className={styles.cardOverlay} onClick={this.handleClose} />
          </div>
        )}
        <div
          className={styles.Card}
          ref={element => {
            this.element = element
          }}
          style={{
            left: stringify(positionXShift),
            top: stringify(positionYShift),
          }}
        >
          <div className={styles.WithDivider}>
            <div
              className={styles[`card-title-wrapper`]}
              style={
                showLockedStyle
                  ? lockedTitleStyle
                  : {
                      backgroundColor: `${typeColor}`,
                    }
              }
            >
              {showStatus && (
                <div className={styles.StatusWrapper}>
                  <div
                    className={styles.StatusCircle}
                    style={{
                      backgroundColor: `${status.color}`,
                    }}
                  />
                </div>
              )}
              <TooltipSpan
                className={styles[`card-title-text`]}
                tooltip={name}
                tooltipConfig={{
                  placement: `bottom`,
                }}
              >
                {name}
              </TooltipSpan>
              {showLockedStyle && (
                <Box loose pl="2px" pt="2px">
                  <LockedIcon size="small" color="#8c8c8c" />
                </Box>
              )}
            </div>
            <Flex className={styles[`card-edit-wrapper`]}>
              <ContentCell className={styles[`icon-title-wrapper`]}>
                <TooltipSpan
                  onClick={this.handleEdit}
                  tooltip="Редактировать событие"
                  tooltipConfig={{
                    placement: `bottom`,
                  }}
                >
                  <EditIcon size="medium" className={styles.icon} />
                </TooltipSpan>
              </ContentCell>
              {deleteButton}
              {eventTypeExternalLink && (
                <Box
                  loose
                  pl="2md"
                  pt="2md"
                  pr="2md"
                  className={styles.ExternalLink}
                >
                  <ExternalLink data={eventTypeExternalLink} />
                </Box>
              )}
            </Flex>
          </div>
          {isCustomFieldAvailable && (
            <Flex className={styles.WithDivider}>
              <Box loose pl="2md" pt="2md">
                <p className={styles.CustomFieldTitle}>
                  {featuresCustomField.parameters.name}
                </p>
              </Box>
              <Box loose pl="2md" pt="2md">
                <p className={styles.CustomFieldValue}>
                  {original.customField}
                </p>
              </Box>
            </Flex>
          )}
          {irStatusAvailable && !isYear && (
            <Box pl="2md" pr="2md" pt="2md">
              <FieldSet caption="Статус">
                <StatusSelect
                  disabled={disableStatus || locked || get(planInfo, `locked`)}
                  status={status}
                  eventUuid={eventUuid}
                  type="eventCalendar"
                />
              </FieldSet>
            </Box>
          )}
          <div className={styles[`card-content`]}>
            {planAllEventsValidate && planAllEventsValidate[eventUuid] && (
              <Flex>
                <ValidateCarousel errors={planAllEventsValidate[eventUuid]} />
              </Flex>
            )}
            <Box loose pl="2md" pr="2md">
              <Flex>
                <ContentCell className={styles[`icon-wrapper`]}>
                  <EventTypesMenuIcon
                    size="medium"
                    className={styles.contentIcon}
                    style={{ marginLeft: `-2px` }}
                  />
                </ContentCell>
                <ContentCell>
                  <span className={styles[`content-text`]}>
                    {type || typeForGroup}
                  </span>
                </ContentCell>
              </Flex>
              <Flex>
                <ContentCell className={styles[`icon-wrapper`]}>
                  <TimeIcon size="medium" className={styles.contentIcon} />
                </ContentCell>
                <ContentCell>
                  <Box loose mt="-1md">
                    <span className={styles[`content-text`]}>
                      {!onlyDate &&
                        moment(start)
                          .local()
                          .format(`LT`)}
                      <span style={{ paddingLeft: !onlyDate && `8px` }}>
                        {`${moment(start).format(`L`)} – `}
                      </span>
                      {!onlyDate && moment(end).format(`LT`)}
                      <span style={{ paddingLeft: !onlyDate && `8px` }}>
                        {moment(end).format(`L`)}
                      </span>
                    </span>
                  </Box>
                </ContentCell>
              </Flex>
              {description && (
                <Flex>
                  <ContentCell className={styles[`icon-wrapper`]}>
                    <ListViewIcon
                      size="medium"
                      className={styles.contentIcon}
                      style={{ marginLeft: `-2px` }}
                    />
                  </ContentCell>
                  <ContentCell>
                    <span className={styles[`content-text`]}>
                      {description}
                    </span>
                  </ContentCell>
                </Flex>
              )}
              {planInfo && (
                <Flex>
                  <ContentCell className={styles[`icon-wrapper`]}>
                    <PlanTasksIcon
                      size="medium"
                      className={styles.contentIcon}
                    />
                  </ContentCell>
                  <ContentCell>
                    <span className={styles[`content-text`]}>
                      {planInfo.name}
                    </span>
                  </ContentCell>
                </Flex>
              )}
              <Flex>
                <ContentCell className={styles[`icon-wrapper`]}>
                  <LinkIcon size="medium" className={styles.contentIcon} />
                </ContentCell>
                <ContentCell>
                  <Flex column>
                    {!eventResourcesPending ? (
                      Object.entries(
                        groupBy(eventResourcesData, `resourceTypeName`),
                      ).map(item => (
                        <Flex
                          key={item[1][0].resourceTypeName}
                          column
                          className={styles[`content-resource`]}
                        >
                          <span className={styles[`content-resource-type`]}>
                            {item[0]} ({item[1].length})
                          </span>
                          {item[1].map(resource =>
                            resource.deleteDate ? (
                              <TooltipSpan
                                key={resource.uuid}
                                className={cn(
                                  styles[`content-resource-name`],
                                  styles[`content-resource-name_deleted`],
                                )}
                                tooltip={resource.name}
                                tooltipConfig={{
                                  placement: `right`,
                                }}
                              >
                                <DeletedIcon className={styles.DeletedIcon} />
                                {` ${resource.name}`}
                              </TooltipSpan>
                            ) : (
                              <TooltipSpan
                                key={resource.uuid}
                                className={styles[`content-resource-name`]}
                                tooltip={resource.name}
                                tooltipConfig={{
                                  placement: `right`,
                                }}
                              >
                                {resource.name}
                              </TooltipSpan>
                            ),
                          )}
                        </Flex>
                      ))
                    ) : (
                      <div className={styles[`loader-wrapper`]}>
                        <LoaderBox color="#2880ff" />
                      </div>
                    )}
                  </Flex>
                </ContentCell>
              </Flex>
            </Box>
          </div>
          <EventCardConnectedInfo
            eventData={{
              uuid: get(data, `originId`),
              startDateTime: get(data, `start_time._i`),
              endDateTime: get(data, `end_time._i`),
            }}
            currentResourceUuid={get(data, `resourceUuid`)}
            resourcesData={get(eventResources, `data`)}
          />
        </div>
        <ModalConfirm
          isOpen={isConfirmationModalOpen}
          title="Вы действительно хотите удалить это событие?"
          buttonConf={[
            {
              text: `Удалить`,
              onClick: this.handleRemove,
              isOk: true,
              done: true,
              disabled: false,
            },
            {
              text: `Отмена`,
              onClick: this.handleToggleConfirmationModalOpen,
              disabled: false,
            },
          ]}
          isRemove
        >
          <div className={styles[`modal-message-wrapper`]}>
            <P className={styles[`modal-message-text`]}>{type}</P>
            <span className={styles[`content-text`]}>
              {!onlyDate &&
                moment(start)
                  .local()
                  .format(`LT`)}
              <span style={{ paddingLeft: !onlyDate && `8px` }}>
                {`${moment(start).format(`L`)} – `}
              </span>
              {!onlyDate && moment(end).format(`LT`)}
              <span style={{ paddingLeft: !onlyDate && `8px` }}>
                {moment(end).format(`L`)}
              </span>
            </span>
          </div>
        </ModalConfirm>
      </div>
    )
  }
}

export default connect(
  (state, { eventUuid }) => ({
    irStatusAvailable: selectStatusAvailable(state),
    calendarEventData: selectEvent(state, eventUuid),
    featuresCustomField: selectEventCustomField(state),
  }),
  null,
)(EventCard)
